import React, {useState, useRef, useEffect, useCallback} from 'react'
import { CountdownCircleTimer } from "react-countdown-circle-timer";

const minuteSeconds = 60;
const hourSeconds = 3600;
const daySeconds = 86400;


const renderTime = (dimension, time) => {
  return (
    <div className="time-wrapper">
      <div className="time">{time < 10 ? "0" + time : time}</div>
    </div>
  );
};

const getTimeSeconds = (time) => (minuteSeconds - time) | 0;
const getTimeMinutes = (time) => ((time % hourSeconds) / minuteSeconds) | 0;
const getTimeHours = (time) => ((time % daySeconds) / hourSeconds) | 0;
const getTimeDays = (time) => (time / daySeconds) | 0;

export default function CircleCountdown({ ...props}) {
  const stratTime = Date.now() / 1000; // use UNIX timestamp in seconds
  let endTime = 0
  let wrongDateFormat = false

  if(props["end-time"] == undefined) {
      endTime = stratTime + 100;
  } else {
      try {
          endTime = Date.parse(props["end-time"])/1000;
      } catch (e) {
          wrongDateFormat = true
      }

  }

  const colors = props["colors"].split(";")
  const labels = props["labels"].split(";")
  const remainingTime = endTime - stratTime;
  const days = Math.ceil(remainingTime / daySeconds);
  const daysDuration = days * daySeconds;
  const removeMinutes = props["remove-minutes"]  || false
  const removeSeconds = props["remove-seconds"]  || false

  const timerProps = {
      isPlaying: true,
      size: props.size,
      strokeWidth: props["strokeWidth"]
    };

  if(wrongDateFormat) {
      return(<div className="alert alert-danger">Wrong Date Format</div>)
  }

  return (
      <>
        <div className="circle-countdown">
          <CountdownCircleTimer
            {...timerProps}
            colors={colors[0]}
            duration={daysDuration}
            initialRemainingTime={remainingTime}
          >
            {({ elapsedTime, color }) => (
              <span style={{ color }}>
                {renderTime("days", getTimeDays(daysDuration - elapsedTime))}
              </span>
            )}
          </CountdownCircleTimer>
          <CountdownCircleTimer
            {...timerProps}
            colors={colors[1]}
            duration={daySeconds}
            initialRemainingTime={remainingTime % daySeconds}
            onComplete={(totalElapsedTime) => ({
              shouldRepeat: remainingTime - totalElapsedTime > hourSeconds
            })}
          >
            {({ elapsedTime, color }) => (
              <span style={{ color }}>
                {renderTime("hours", getTimeHours(daySeconds - elapsedTime))}
              </span>
            )}
          </CountdownCircleTimer>
          {!removeMinutes&&
            <CountdownCircleTimer
            {...timerProps}
            colors={colors[2]}
            duration={hourSeconds}
            initialRemainingTime={remainingTime % hourSeconds}
            onComplete={(totalElapsedTime) => ({
              shouldRepeat: remainingTime - totalElapsedTime > minuteSeconds
            })}
          >
            {({ elapsedTime, color }) => (
              <span style={{ color }}>
                {renderTime("minutes", getTimeMinutes(hourSeconds - elapsedTime))}
              </span>
            )}
          </CountdownCircleTimer>}
            {!removeSeconds&&
            <CountdownCircleTimer
            {...timerProps}
            colors={colors[3]}
            duration={minuteSeconds}
            initialRemainingTime={remainingTime % minuteSeconds}
            onComplete={(totalElapsedTime) => ({
              shouldRepeat: remainingTime - totalElapsedTime > 0
            })}
          >
            {({ elapsedTime, color }) => (
              <span style={{ color }}>
                {renderTime("seconds", getTimeSeconds(elapsedTime))}
              </span>
            )}
          </CountdownCircleTimer>}
        </div>
          <div className="circle-countdown-text">
              <span className="circle-desc">{labels[0]}</span>
              <span className="circle-desc">{labels[1]}</span>
              {!removeMinutes &&
                <span className="circle-desc">{labels[2]}</span>
              }
              {!removeSeconds &&
                <span className="circle-desc">{labels[3]}</span>
              }
          </div>
      </>
  );
}